import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-additional-services-top-bar',
  templateUrl: './additional-services-top-bar.component.html',
  styleUrls: ['./additional-services-top-bar.component.scss']
})
export class AdditionalServicesTopBarComponent implements OnInit {

  // params
  id: number;

  constructor(
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {

    this._route.params.subscribe((params: any) => {
      if (params.id) {
        this.id = params.id;
      }
    });

  }

}
